import { Checkbox } from "semantic-ui-react";

function YesNoToggle({ value, onChange, name = "required" }) {
  return (
    <div style={{ display: "flex", gap: "1em", margin: "1em 0" }}>
      <label>No</label>
      <Checkbox
        toggle
        name={name}
        checked={value}
        value={value}
        onChange={(e, f) => {
          onChange(e, { name: f.name, value: f.checked });
        }}
      />
      <label>Yes</label>
    </div>
  );
}

export default YesNoToggle;
